import React, { useState, FC, useEffect } from "react";
import { Space, Select } from "antd";
import { useQuery } from "@apollo/react-hooks";
import { OrgGql } from "../graphql/organization";
const { Option } = Select;

interface GradePickerProps {
  value?: string[];
  onChange?: (value: string[]) => void;
}

export const GradePicker: FC<GradePickerProps> = ({ value, onChange }) => {
  const { data: { gradeList } = { gradeList: [] } } = useQuery<{ gradeList: string[] }>(OrgGql.gradeList);
  const [start, setStart] = useState<string | undefined>(value?.[0]);
  const [end, setEnd] = useState<string | undefined>(value?.[value?.length - 1]);

  useEffect(() => {
    if (!value || value.length === 0) {
      setStart(undefined);
      setEnd(undefined);
    } else if (value.length === 1) {
      setStart(value[0]);
      setEnd(value[0]);
    } else {
      setStart(value[0]);
      setEnd(value[value.length - 1]);
    }
  }, [value]);

  const triggerChange = (from?: string, to?: string) => {
    let data: string[] = [];
    if (from && to) {
      const iFrom = gradeList.indexOf(from);
      const iTo = gradeList.indexOf(to);
      data = gradeList.slice(iFrom, iTo + 1);
    } else if (from) {
      data = [from];
    } else if (to) {
      data = [to];
    }
    onChange && onChange(data);
  };

  const onStart = (v) => {
    triggerChange(v, end);
  };
  const onEnd = (v) => {
    triggerChange(start, v);
  };

  return (
    <Space>
      <Select value={start} style={{ width: 120 }} onChange={onStart}>
        {gradeList.map((x) => (
          <Option value={x} key={x}>
            {x}
          </Option>
        ))}
      </Select>
      <Select value={end} style={{ width: 120 }} onChange={onEnd}>
        {gradeList.map((x) => (
          <Option value={x} key={x}>
            {x}
          </Option>
        ))}
      </Select>
    </Space>
  );
};
